import { Box, Button, Icon, Paper, TextField, Typography } from '@mui/material';
import React, { DragEvent, memo } from 'react';

const style: { [key: string]: React.CSSProperties } = {
  title: {
    position: 'relative',
    padding: '8px 8px',
    marginTop: '8px',
    flexGrow: 1,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '10px',
    marginLeft: '10px'
  },
  aside: {
    borderRight: '1px solid #eee',
    padding: '15px 10px',
    fontSize: '12px',
    background: '#fcfcfc',
    width: '180px',
  }

};

const onDragStart = (event: DragEvent, nodeType: string) => {
  event.dataTransfer.setData('application/reactflow', nodeType);
  event.dataTransfer.effectAllowed = 'move';
};

interface sidebarProps {
  isEditable:boolean;
  canChangeStatus:boolean;
  status:string;
  handleValidar?: () => void;
  handleSalvar?: () => void;
  handleVoltar?: () => void;
  handleAlterarStatus?: () => void;
}

const Sidebar: React.FC<sidebarProps> = ({
  isEditable,
  canChangeStatus,
  status,
  handleValidar,
  handleSalvar,
  handleVoltar,
  handleAlterarStatus
}) => {
  const customTitle = { ...style.title };
  if (isEditable) customTitle.cursor = 'grab';
  return (
    <Box component="aside" style={style.aside}>
      <Box p={1} component={Paper} >
        <Box p={1} component={Paper}  >
          <Typography
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipses"
            variant={'h6'}
            align='center'
          >
            Componentes
          </Typography>
        </Box>

        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#F2F2F2' }} onDragStart={(event: DragEvent) => onDragStart(event, 'inicio')} draggable={isEditable}>
          <Icon style={style.icon}>play_circle</Icon>
          Início
        </Box>
        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#C2BA7C' }} onDragStart={(event: DragEvent) => onDragStart(event, 'fim')} draggable={isEditable}>
          <Icon style={style.icon}>stop_cicle</Icon>
          Fim
        </Box>
        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#8E95BF' }} onDragStart={(event: DragEvent) => onDragStart(event, 'campanha')} draggable={isEditable}>
          <Icon style={style.icon}>campaign</Icon>
          Campanha
        </Box>
        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#808000' }} onDragStart={(event: DragEvent) => onDragStart(event, 'campanhaOnl')} draggable={isEditable}>
          <Icon style={style.icon}>campaign</Icon>
          Campanha Online
        </Box>
        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#F2CE16' }} onDragStart={(event: DragEvent) => onDragStart(event, 'condicional')} draggable={isEditable}>
          <Icon style={style.icon}>question_mark</Icon>
          Condicional
        </Box>
        <Box className="react-flow__node-default" style={customTitle} sx={{ bgcolor: '#C2A95F' }} onDragStart={(event: DragEvent) => onDragStart(event, 'sleep')} draggable={isEditable}>
          <Icon style={style.icon}>timer</Icon>
          Sleep
        </Box>
      </Box>


      <Box display="flex" flexDirection='column' position='fixed' bottom='10px' width='180px'>
        <Box p={1} display="flex"  flexDirection='column'>
          
          <TextField
            margin='normal'
            size='small'
            type='text'
            disabled
            label='Status'
            value={status}
          />
          <Button
            disabled={!canChangeStatus}
            color='primary'
            variant='contained'
            onClick={handleAlterarStatus}
          >
            Alterar Status
          </Button>
          

        </Box>
        
        <Box p={1} display="flex"  flexDirection='column'>
          <Button
            disabled={!isEditable}
            color='primary'
            variant='contained'
            onClick={handleValidar}
          >
            Validar
          </Button>

        </Box>
        <Box p={1} display="flex" flexDirection='column' >
          <Button
            disabled={!isEditable}
            color='primary'
            variant='contained'
            onClick={handleSalvar}
          >
            Salvar
          </Button>
        </Box>
        <Box p={1} display="flex"  flexDirection='column'>
          <Button
            color='primary'
            variant='contained'
            onClick={handleVoltar}
          >
            Voltar
          </Button>
        </Box>

      </Box>
    </Box>
  );
};

export default memo(Sidebar);

